"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _default = new _immutable.Record({
  channelGuid: null,
  portalId: null,
  channelId: null,
  accountGuid: null,
  name: null,
  createdAt: null,
  updatedAt: null,
  active: null,
  shared: null,
  channelKey: null,
  followMe: null,
  reach: null,
  autoPublish: null,
  monitoring: null,
  hidden: null,
  settings: null,
  twitterId: null,
  twitterScreenName: null,
  reachType: null,
  type: null,
  displayName: null,
  accountType: null,
  dataMap: null,
  accountSlug: null,
  userName: null,
  profileUrl: null,
  avatarUrl: null,
  channelSlug: null
}, 'Channel');

exports.default = _default;
module.exports = exports.default;